export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sporne kolumny"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nastawić"])}
}